import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class ChargeAmountResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('ChargeAmount');
    }
    public withChargeTotal = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['chargeTotal'] = this.initField(null, args);
        return this;
    }

    public withCrossedOut = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['crossedOut'] = this.initField(null, args);
        return this;
    }
}
